import { TDispatch } from 'state';
import ErrorNotifier from '../../../../../services/error-notifier';
import getMessageAuditLog from '../../api/audit';
import { messageAuditLogParser } from '../parsers';
import { fetchMessageAuditLogSuccess, fetchMessageAuditLogFailure } from './index';

type Payload = {
  messageId: string;
  limit?: number;
  offset?: number;
  isOnlyManual?: boolean;
  userId?: string;
  timestamp?: number;
};

const fetchMessageAuditLog = ({
  messageId,
  isOnlyManual = false,
  limit = 40,
  offset = 0
}: Payload) => {
  return async (dispatch: TDispatch): Promise<void> => {
    try {
      const response = await getMessageAuditLog({ messageId, isOnlyManual, limit, offset });

      // Parsing the response
      const { users, timeline } = messageAuditLogParser(response);

      dispatch(fetchMessageAuditLogSuccess({ messageId, users, timeline, isOnlyManual }));
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError(`Failed to fetch message audit log`, { messageId, isOnlyManual });
      dispatch(fetchMessageAuditLogFailure({ isOnlyManual, messageId }));
    }
  };
};

export default fetchMessageAuditLog;
